import CallIcon from "@mui/icons-material/Call";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MailIcon from "@mui/icons-material/Mail";
import { Box, Container, Stack, TableRow, Typography } from "@mui/material";
import React, { useRef } from "react";
import AppLogo from "../../assets/images/Trust-telecom-New-Logo.png";
import ContractTable from "./../../app/marketingAgent/contractPreview/ContractTable";
import {
  calculateEarlyTerminationCharge,
  calcultePackageAmount,
  checkIfPaygExists,
  formatObjKey,
  renderAdditionalService,
  renderKeyPairsRows,
  renderTableDetailsForLegacy,
  renderTableDetailsForNgN,
} from "../../utils/helper";

const headerFooterStyles = {
  position: "absolute",
  top: 0,
  left: 0,
  height: "inherit",
};

const thirdTableData = [
  { feature: "Calls to Landline (01,02 & 03)", details: "4p" },
  { feature: "Calls to major mobile networks", details: "16p" },
  {
    feature: "UK Landline - Connection Charge",
    details: "18p",
  },
  {
    feature: "UK Mobile - Connection Charge",
    details: "28p",
  },
];

const ContractSummaryPdf = ({ row }) => {
  const {
    cliData,
    contractLength,
    downloadSpeed,
    uploadSpeed,
    routerValue,
    isReqDebitDetail,
    generalInfo,
    isDebitDetails,
    totalOneOfCost,
    totalGrossProfit,
    calculateTotalRevenue,
  } = row;
  const pdfRef = useRef(null);

  const isPaygExists = checkIfPaygExists(cliData);

  const totalRevenue = calculateTotalRevenue();

  const renderSelectedService = () => {
    return cliData?.map((valll, mainIndex) => {
      if (
        valll?.legacyTariff?.isSelected === true &&
        valll?.lineValues[0]?.legacy?.value
      ) {
        let cliNumber = valll?.cliNumber ? valll?.mobileNo : "New Connection";
        let showHeader = `${valll?.lineValues[0]?.legacy?.value} x ${valll?.lineValues?.length} / ${cliNumber}`;
        return (
          <ContractTable
            key={mainIndex}
            primary={showHeader}
            secondary={"Details"}
            data={renderTableDetailsForLegacy(valll, mainIndex, contractLength)}
          />
        );
      }
      if (valll?.digitalTariff?.isSelected === true) {
        return valll.lineValues?.map((itemm, index) => {
          let ngnValueName = itemm?.ngnValue?.value;
          let cliNumber = valll?.cliNumber ? valll?.mobileNo : "New Connection";

          if (ngnValueName) {
            return (
              <ContractTable
                key={index}
                primary={`${ngnValueName} / ${cliNumber} / Line ${index + 1}`}
                secondary={"Details"}
                data={renderTableDetailsForNgN(
                  valll,
                  itemm,
                  mainIndex,
                  contractLength
                )}
              />
            );
          }
        });
      }
    });
  };

  const secondTableData = [
    {
      feature: "Router Shipping and Handling",
      details: `£${routerValue.price}`,
    },
    // not showing now
    // {
    //   feature: "Platform Upgrade Charge",
    //   details: `£${
    //     sogeaUpgradeCharge.isSelected ? sogeaUpgradeCharge.salePrice : 0
    //   }`,
    // },
    {
      feature: "Early Termination Fee (for breach of contract)",
      // details: "£499",
      details: `£${calculateEarlyTerminationCharge(totalRevenue, contractLength)}`,
    },
  ];

  const fourthTableData = [
    {
      feature: "Download",
      details: `${downloadSpeed?.min} to ${downloadSpeed?.max} Mbps`,
    },
    {
      feature: "Upload",
      details: `${uploadSpeed?.min} to ${uploadSpeed?.max} Mbps`,
    },
  ];

  const renderInstallatuionDetails = () => {
    return secondTableData.map((valll, index) => {
      return (
        <TableRow key={index}>
          <td
            className="table-cell"
            style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
          >
            {valll.feature}
          </td>
          <td
            className="table-cell"
            style={{ width: "50%", textAlign: "center" }}
          >
            {valll.details}
          </td>
        </TableRow>
      );
    });
  };
  const renderPaygValues = () => {
    return thirdTableData.map((valll, index) => {
      return (
        <TableRow key={index}>
          <td
            className="table-cell"
            style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
          >
            {valll.feature}
          </td>
          <td
            className="table-cell"
            style={{ width: "50%", textAlign: "center" }}
          >
            {valll.details}
          </td>
        </TableRow>
      );
    });
  };
  const renderUploadAndDownload = () => {
    return fourthTableData?.map((valll, index) => {
      return (
        <TableRow key={index}>
          <td
            className="table-cell"
            style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
          >
            {valll.feature}
          </td>
          <td
            className="table-cell"
            style={{ width: "50%", textAlign: "center" }}
          >
            {valll.details}
          </td>
        </TableRow>
      );
    });
  };
  const renderAddHocServices = () => {
    if (!isDebitDetails || generalInfo?.eBilling == "No") {
      return (
        <>
          {generalInfo.eBilling == "No" && (
            <TableRow>
              <td
                className="table-cell"
                style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
              >
                Paper Billing Charges
              </td>
              <td
                className="table-cell"
                style={{ width: "50%", textAlign: "center" }}
              >
                £5
              </td>
            </TableRow>
          )}
          {!isDebitDetails && (
            <TableRow>
              <td
                className="table-cell"
                style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
              >
                Payment Processing Fee
              </td>
              <td
                className="table-cell"
                style={{ width: "50%", textAlign: "center" }}
              >
                £7
              </td>
            </TableRow>
          )}
        </>
      );
    }
  };

  const renderTotalCharges = () => {
    return (
      <>
        <TableRow>
          <td
            className="table-cell"
            style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
          >
            Total One Of Cost{" "}
          </td>
          <td
            className="table-cell"
            style={{ width: "50%", textAlign: "center" }}
          >
            £{totalOneOfCost}
          </td>
        </TableRow>
        <TableRow>
          <td
            className="table-cell"
            style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
          >
            Total Monthly Bill{" "}
          </td>
          <td
            className="table-cell"
            style={{ width: "50%", textAlign: "center" }}
          >
            £{totalGrossProfit}
          </td>
        </TableRow>
      </>
    );
  };

  return (
    <Container maxWidth="lg">
      <Box bgcolor="#726c60" height={65} position="relative">
        <Box
          bgcolor="primary.main"
          sx={{
            ...headerFooterStyles,
            width: "150px",
            zIndex: 99,
            clipPath: "polygon(0 -2%, 0% 300%, 100% 0)",
          }}
        />
        <Box
          bgcolor="secondary.light"
          sx={{
            ...headerFooterStyles,
            width: "190px",
            clipPath: "polygon(0 -11%, 0% 400%, 100% 0)",
          }}
        />
      </Box>

      <Stack
        mt={3}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <img src={AppLogo} width={250} alt="App Logo" />
        <Stack alignItems={"center"}>
          <Typography>63-66 Hatton Garden Fifth Floor</Typography>
          <Typography>Suite 23, London, EC1N 8LE</Typography>
          <Typography>Email: support@trust.telecom.co.uk</Typography>
          <Typography>Support Number - 0845 5610055 </Typography>
          <Typography>Registered Company Number - 13050404 </Typography>
          <Typography>VAT-369 8634 35 </Typography>
        </Stack>
      </Stack>

      <Typography
        variant="h4"
        textAlign="center"
        borderBottom="2px solid black"
        display="table"
        margin="auto"
        fontWeight={500}
      >
        Contract Summary
      </Typography>

      <Typography my={2} variant="body1" fontSize="1.125rem">
        Dear 4,5
      </Typography>

      <Typography my={2} variant="body1" fontSize="1.125rem">
        Please find enclosed a detailed breakdown of your preferred tariff.
      </Typography>
      {/* contract Table */}
      <Stack spacing={1}>
        {renderSelectedService()}
        <ContractTable
          primary={"Hardware,Installation,Early Termination"}
          secondary={"One-off Costs"}
          data={renderInstallatuionDetails()}
        />
        {isPaygExists && (
          <ContractTable
            primary={"PAYG Call Charges"}
            secondary={"Sale Price"}
            data={renderPaygValues()}
          />
        )}

        <ContractTable
          primary={"Internet Data Transfer"}
          secondary={"Speed Range,Minimun to Maximum"}
          data={renderUploadAndDownload()}
        />
        {(!isDebitDetails || generalInfo?.eBilling == "No") && (
          <ContractTable
            primary={"Ad hoc Services/Charges"}
            secondary={"Sale Price"}
            data={renderAddHocServices()}
          />
        )}

        <ContractTable
          primary={"Types of Charges"}
          secondary={"Total Amount"}
          data={renderTotalCharges()}
        />
      </Stack>
      {/* contract Table */}
      <Typography my={2} variant="body1" fontSize="1.125rem">
        Trust Business will not automatically renew your contract term or
        increase the cost of your tariff after the initial contract period. Your
        service will continue without interruption. You will be notified 30 days
        in advance of any future price increases and have the right to cancel
        without penalty during that period.
      </Typography>

      <Typography my={2} variant="body1" fontSize="1.125rem">
        If there is a recurring and continuous discrepancy between actual and
        contracted internet performance, you are entitled to cancel free of
        charge.
      </Typography>

      <Typography my={2} variant="body1" fontSize="1.125rem">
        Find our Terms and Conditions, including complaints procedure, attached.
      </Typography>

      <Stack alignItems="flex-end" spacing={1} mt={15} pr={2}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="h6" fontSize="1.125rem" lineHeight="normal">
            63-66 Hatton Garden Fifth Floor, Suite 23, London, EC1N 8LE
          </Typography>
          <LocationOnIcon sx={{ color: "primary.main" }} />
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="h6" fontSize="1.125rem" lineHeight="normal">
            0845 5610055
          </Typography>
          <CallIcon sx={{ color: "primary.main" }} />
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="h6" fontSize="1.125rem" lineHeight="normal">
            support@trust.telecom.co.uk
          </Typography>
          <MailIcon sx={{ color: "primary.main" }} />
        </Stack>
      </Stack>

      <Box
        mt={4}
        bgcolor="#726c60"
        height={65}
        position="relative"
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Box
          bgcolor="primary.main"
          sx={{
            ...headerFooterStyles,
            width: "150px",
            zIndex: 9999,
            clipPath: "polygon(0 -2%, 0% 300%, 100% 0)",
          }}
        />
        <Box
          bgcolor="secondary.light"
          sx={{
            ...headerFooterStyles,
            width: "190px",
            clipPath: "polygon(0 -11%, 0% 400%, 100% 0)",
          }}
        />
        <Typography variant="h6" textAlign={"center"} color={"secondary.light"}>
          www.trust-telecom.co.uk
        </Typography>
      </Box>
    </Container>
  );
};

export default ContractSummaryPdf;
